import { createContext } from "react";
import initial from "./initial";

export default createContext(initial);
